import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src={logo} 
                alt="MGE COUVERTURE Logo" 
                className="h-12 w-auto mr-2" 
              />
              <h3 className="font-heading text-xl font-bold">MGE COUVERTURE</h3>
            </div>
            <p className="mb-4 text-gray-400">
              Votre partenaire de confiance pour tous vos projets de couverture et de rénovation depuis plus de 15 ans.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-light transition-colors">Accueil</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-light transition-colors">Services</Link>
              </li>

              <li>
                <Link to="/faq" className="text-gray-400 hover:text-primary-light transition-colors">FAQ</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-light transition-colors">Contact</Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary-light mt-1 mr-3" />
                <span className="text-gray-400">34 Rue de la Foret, 91860 Epinay-Sous-Senart, France</span>
              </li>

              <li className="flex items-center">
                <FontAwesomeIcon icon={faEnvelope} className="text-primary-light mr-3" />
                <span className="text-gray-400">mgecouverture@gmail.com</span>
              </li>
            </ul>
          </div>
          
          {/* Legal Info */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Informations Légales</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal-notice" className="text-gray-400 hover:text-primary-light transition-colors">Mentions Légales</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-primary-light transition-colors">Politique de Confidentialité</Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-400 hover:text-primary-light transition-colors">Conditions d'Utilisation</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-gray-500 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center mb-4 md:mb-0">
              <span className="mr-2 text-white font-medium">By</span>
              <a href="https://aiko-agency.fr/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
                <img 
                  src="/assets/images/logos/aiko.png" 
                  alt="Aiko Agency" 
                  className="h-8 w-auto" 
                />
              </a>
            </div>
            <p>&copy; {currentYear} MGE COUVERTURE. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
